// Social Contribution Initiatives page English translations

export default {
  pageTitle: "Social Contribution Initiatives",
  breadcrumbHome: "Home",
  breadcrumbSustainability: "Sustainability",
  breadcrumbCurrent: "Social Contribution Initiatives",
  title: "Social Contribution Initiatives",
  sustainability: "Sustainability",
  conceptOfSustainability: "Concept of Sustainability",
  environmentalInitiatives: "Environmental Initiatives",
  occupationalHealthSafety: "Occupational Health & Safety",
  
  // Social Contribution Details Section
  socialContributionTitle: "Social Contribution at P.T.  Eagle Industry Indonesia",
  socialContributionDesc: "At P.T.  Eagle Industry Indonesia, we are committed to making a positive impact on society through our Corporate Social Responsibility (CSR) initiatives. Our social contribution programs focus on supporting the community, helping those in need, and fostering sustainable development in the areas surrounding our operations.",
  
  // CSR Activities Section
  csrActivitiesTitle: "CSR Activities",
  csrActivitiesSubtitle: "Our commitment to social responsibility and community support",
  
  // Qurban Activity
  qurbanTitle: "Qurban Activity - Eid al-Adha",
  qurbanDesc: "The company runs an annual Qurban program on Eid al-Adha. Qurban meat distribution is given to orphans/poor/needy around the company.",
  qurbanHighlight1: "Annual Qurban program held every Eid al-Adha",
  qurbanHighlight2: "Distribution of Qurban meat to the underprivileged community",
  qurbanHighlight3: "Focus on orphans, poor, and needy around the company location",
  qurbanHighlight4: "Involving employees in program implementation",
  qurbanCaption: "Eid al-Adha Qurban Activity",
  
  // Ramadhan Charity Activity
  ramadhanTitle: "Ramadhan Charity for Orphans & Needy",
  ramadhanDesc: "The company regularly holds Ramadhan charity activities by inviting orphans to share happiness in the holy month.",
  ramadhanHighlight1: "Regular charity program every Ramadhan",
  ramadhanHighlight2: "Inviting orphans to break fast together",
  ramadhanHighlight3: "Providing assistance in the form of charity and school supplies",
  ramadhanHighlight4: "Creating moments of sharing happiness in the holy month of Ramadhan",
  ramadhanCaption: "Ramadhan Charity for Orphans & Needy",
  
  // Flood Victim Support Activity
  floodVictimTitle: "Company Support for Flood Victims",
  floodVictimDesc: "The company provides assistance to the surrounding community affected by floods as a form of concern for the surrounding environment.",
  floodVictimHighlight1: "Rapid response to flood disasters around the company",
  floodVictimHighlight2: "Distribution of assistance in the form of basic necessities and food supplies",
  floodVictimHighlight3: "Direct assistance to affected flood victims",
  floodVictimHighlight4: "Form of social concern for the surrounding community",
  floodVictimCaption: "Flood Victim Assistance",
  
  // Related Topics Section
  relatedTopicsTitle: "Related Sustainability Topics",
  relatedTopicsSubtitle: "Explore more about our sustainability initiatives",
  conceptOfSustainabilityCard: "Concept of Sustainability",
  environmentalInitiativesCard: "Environmental Initiatives",
  occupationalHealthSafetyCard: "Occupational Health & Safety"
};